/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCreditCardIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-credit-card"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.85 20.75Q2.75 20.75 1.98 19.98Q1.2 19.2 1.2 18.1L1.2 5.9Q1.2 4.8 1.98 4.03Q2.75 3.25 3.85 3.25L20.15 3.25Q21.25 3.25 22.02 4.03Q22.8 4.8 22.8 5.9L22.8 18.1Q22.8 19.2 22.02 19.98Q21.25 20.75 20.15 20.75ZM3.85 12.5L20.15 12.5L20.15 7.45L3.85 7.45Z" fill={color} />
    </svg>
  );
}
